// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FXAxK","col":"styles_col__2f1ZN"};